export default {
  namespaced: true,
  state: {
    loading: false,
    loadingCounter: 0,
    finishPdfProgress: false,
    cancelPdfGeneration: false,
  },
  mutations: {
    setIsLoading(state, value) {
      if (value) {
        state.loadingCounter += 1;
      } else {
        state.loadingCounter -= 1;
      }
      state.loading = state.loadingCounter > 0;
    },
    setFinishPdfProgress(state, value) {
      state.finishPdfProgress = value;
    },
    setCancelPdfGeneration(state, value) {
      state.cancelPdfGeneration = value;
    },
  },
};
